import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AppComponent } from 'src/app/app.component';
import { MessageService } from 'src/app/shared/message.service';
import { EntrySelect } from 'src/app/shared/models/EntrySelect.model';
import { WebSocketContent, sender } from 'src/app/shared/models/webSocketContent';
import { RestService } from 'src/app/shared/services/rest.service';
import { SessionService } from 'src/app/shared/services/session.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-criacao-chamado',
  templateUrl: './criacao-chamado.component.html',
  styleUrls: ['./criacao-chamado.component.css']
})
export class CriacaoChamadoComponent implements OnInit {
  @HostListener('window:unload', ['$event'])
  unloadHandler(event) {
    this.observerProtocolo.unsubscribe();
    this.observerProtocolo = null;
    if (this.travado) {
      let s: WebSocketContent = new WebSocketContent();
      s.code = 23;
      s.content = 'unlock'
      s.recipient = this.uuidUser;
      s.type_recipient = 'self';
      this.app.enviarSocket(s);
    }
  }
  @HostListener('window:beforeunload', ['$event'])
  doSomething(event: BeforeUnloadEvent) {
    event.preventDefault();
    if (this.listaAnexos.length > 0) {
      event.returnValue = 'ATENÇÃO: Os dados inseridos serão perdidos se você sair.';
    }
    /* this.removerAnexos(); */
  }
  form: FormGroup;
  uuid_orcamento: string;
  _data_hora_abertura: string = new Date().toISOString();
  _categorias: Array<EntrySelect> = environment.categoriaChamado;
  post: Array<any> = new Array;
  _arquivo: Object;
  uuidUser: string;
  travado: boolean = false;
  listaAnexos: Array<any> = [];
  listaAnexosExibicao: Array<any> = [];
  chamadoAberto: boolean = false;
  anexosReserva: Array<any> = [];
  observerProtocolo: Subscription;
  protocolo: string = null;
  _session: string;
  timer: any = null;
  anexoStatus: string = null;
  constructor(
    private formB: FormBuilder,
    private rest: RestService,
    private app: AppComponent,
    private session: SessionService,
    private info: MessageService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this._session = new sender().session;
    this.protocolo = null;
    this.form = this.formB.group({
      assunto: [null, [Validators.required]],
      categoria: [null, [Validators.required]],
      protocoloOrcamento: [null, [Validators.nullValidator]],
    });
    this.form.get('categoria').setValue(this._categorias[0].value);
    let i = setInterval(() => {
      this.obterProtocolo();
      clearInterval(i);
    }, 250);
    this.uuidUser = this.session.getUUIDUsuario();
    this.observerProtocolo = this.app.protocoloChamado.subscribe((r: WebSocketContent) => {
      if (r.code == 21 && r.sender.uuid == "007" && r.sender.name == 'server-msg' && r.recipient == this.uuidUser && this.protocolo == null) {
        clearInterval(this.timer);
        this.protocolo = r.content;
        this.obterAnexos();
      } else if (r.code == 21 && r.sender.uuid == "007" && r.sender.name == 'server-msg' && r.recipient == this.uuidUser && this.protocolo == r.content && r.sender?.session != this._session) {
        //esta condição é para caso o WebSocket identifique um novo chamado com o mesmo protocolo, o que causaria trastornos para os usuário, pois teria 2 chamados com o mesmo protocolo
        let s: WebSocketContent = new WebSocketContent();
        s.code = 23;
        s.content = 'lock'
        s.recipient = this.uuidUser;
        s.type_recipient = 'self';
        this.app.enviarSocket(s);
        this.travado = true;
        this.alertProtocoloRepetido();
      }
      else if (r.code == 23 && r.recipient == this.uuidUser && r.type_recipient == 'self' && r.content == 'lock') {
        this.travado = true;
        this.alertProtocoloRepetido();
      }
      else if (r.code == 23 && r.recipient == this.uuidUser && r.type_recipient == 'self' && r.content == 'unlock') {
        this.travado = false;
        this.info.close();
      }
    });
  }

  alertProtocoloRepetido() {
    this.info.customAlert({
      icon: 'info',
      text: 'Foi identificado uma nova aba de chamados aberta por você, feche uma das abas para dar continuidade na abertura do chamado.' + (this.listaAnexos.length > 0 ? ' Os dados inseridos serão perdidos se você sair.' : ''),
      showDenyButton: true,
      showConfirmButton: true,
      confirmButtonText: 'Manter esta aba',
      denyButtonText: 'Fechar esta aba',
      denyButtonColor: 'red',
      confirmButtonColor: 'green'
    }).then((d: any) => {
      if (d.isDenied) {
        let s: WebSocketContent = new WebSocketContent();
        s.code = 23;
        s.content = 'unlock'
        s.recipient = this.uuidUser;
        s.type_recipient = 'self';
        this.app.enviarSocket(s);
        this.router.navigate(['chamados']);
      } else if (d.isConfirmed) return;
    });
  }

  obterProtocolo() {
    let jsonSocketObterProtocolo = new WebSocketContent();
    let _sender = new sender();
    jsonSocketObterProtocolo.code = 21;
    _sender.name = this.session.retornaLogin();
    _sender.uuid = this.uuidUser;
    _sender.session = this._session;
    jsonSocketObterProtocolo.sender = _sender;
    jsonSocketObterProtocolo.type_recipient = 'server';
    jsonSocketObterProtocolo.recipient = 'server';
    this.app.enviarSocket(jsonSocketObterProtocolo);
    this.timer = setInterval(() => {
      this.obterProtocoloAPI();
      clearInterval(this.timer);
      this.timer = null;
    }, 500);
  }

  obterProtocoloAPI() {//essa função é chamada caso o protocolo não tenha sido obtido pelo WebSocket
    if (!this.protocolo) {
      this.rest.obterProtocoloChamado().subscribe((data: any) => {
        if (data.status == 'success') {
          this.protocolo = data.data;
          this.obterAnexos();
        } else {
          this.info.showAlert('Tivemos um problema em gerar seu protocolo<br> Tente novamente mais tarde');
          this.router.navigate(['chamados']);
        }
      });
    }
  }

  obterAnexos() {
    this.rest.obterAnexos(this.protocolo).subscribe((data: any) => {
      if (data.status == 'success') {
        this.anexosReserva = data.data;
        this.info.customAlert({
          icon: 'question',
          title: 'Anexos encontrados',
          text: 'Identificamos que você esta abrindo um chamado anteriormente e anexou arquivos nele, gostaria de manter os anexos?',
          showConfirmButton: true,
          confirmButtonColor: 'green',
          confirmButtonText: 'Manter Anexos',
          showDenyButton: true,
          denyButtonColor: 'red',
          denyButtonText: 'Descartar Anexos'
        }).then((e: any) => {
          if (e.isConfirmed) {
            this.anexosReserva.forEach((e: any) => {
              this.listaAnexosExibicao.push({ "nome": e.nome_arquivo, "uuid": e.uuid });
            });
          }
          else {
            let aux: Array<any> = [];
            this.anexosReserva.forEach((e: any) => {
              aux.push(e.uuid);
            });
            this.rest.removerAnexosDoChamado(this.protocolo, aux).subscribe((data: any) => {
              this.anexosReserva = [];
            })
          }
        });
      }
    });
  }

  async salvarArquivos(arquivo: any) {
    arquivo = arquivo.files;
    this.anexoStatus = 'Salvando'
    for (let i = 0; i < arquivo.length; i++) {
      const file = arquivo[i];
      let nome = file.name
      let extensao = String(arquivo[i].name).split('.')[String(arquivo[i].name).split('.').length - 1];
      // Encode the file using the FileReader API
      const reader = new FileReader();
      reader.onloadend = () => {
        // Use a regex to remove data url part
        const base64String = String(reader.result)
          .replace('data:', '')
          .replace(/^.+,/, '');

        let jsonArquivo = {
          "extensao": extensao,
          "arquivoBase64": base64String,
          "nomeArquivo": nome
        }
        this.enviarArquivo(jsonArquivo);

        return (base64String)
        // Logs wL2dvYWwgbW9yZ...
      };
      reader.readAsDataURL(file);
    }
  }

  async enviarArquivo(jsonArquivo: any) {
    if (jsonArquivo) {
      //req para salvar arquivo
      this.rest.salvarAnexos(jsonArquivo, this.protocolo, this.uuidUser).subscribe((data: any) => {
        if (data.status == 'success') {
          this.listaAnexos.push(data.uuid)
          this.listaAnexosExibicao.push({ "nome": jsonArquivo.nomeArquivo, "uuid": data.uuid });
          this.anexoStatus = 'Salvo';
          let i = setInterval(() => {
            this.anexoStatus = null;
            clearInterval(i);
          }, 1000)
        };
      });
    }
    $('#input-arquivos').val(null);
  }

  abrirChamado() {
    if (!this.form.valid) {
      this.info.showAlert('Preencha os campos obrigatórios')
      return;
    }
    if (this.protocolo) {
      let categoria = Number(this.form.get('categoria').value);
      let assunto = this.form.get('assunto').value;
      let descricao = String($('#desc').val());
      let protocoloOrcamento = this.form.get('protocoloOrcamento').value;
      this.rest.abrirChamado(categoria, assunto, descricao, this.protocolo, protocoloOrcamento).subscribe((data: any) => {
        if (data.status == 'success') {
          this.chamadoAberto = true;
          this.router.navigate(['chamados/interacao/' + this.protocolo]);
        }
      });
    } else {
      this.app.forceReconnect();
      this.app._reconnect.subscribe((d: any) => {
        if (d == 'reconnected') {
          this.abrirChamado();
          this.app._reconnect.unsubscribe();
        }
      });
    }
  }
  abrirArquivo(uuid) {
    this.rest.obterURLAnexoEspecifico(this.protocolo, uuid).subscribe((data: any) => {
      if (data.status == 'success') {
        window.open(data.url, '_black');
      }
    })
  }

  ifParaListagem() {
    this.observerProtocolo.unsubscribe();
    this.router.navigate(['chamados'])
  }
}